import { render, staticRenderFns } from "./exam_detail.vue?vue&type=template&id=bfbb677c&scoped=true"
import script from "./exam_detail.vue?vue&type=script&lang=js"
export * from "./exam_detail.vue?vue&type=script&lang=js"
import style0 from "./exam_detail.vue?vue&type=style&index=0&id=bfbb677c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbb677c",
  null
  
)

export default component.exports